/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowDownToLine: {
  name: 'arrow-down-to-line';
  data: string;
} = {
  name: 'arrow-down-to-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 5a1 1 0 1 0-2 0v9.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l4 4c.195.195.45.293.706.293H7a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2h-5a.997.997 0 0 0 .707-.293l4-4a1 1 0 0 0-1.414-1.414L13 14.586V5Z" fill="currentColor"/></svg>`,
};
